import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

const Header = ({
  properties,
  colClassName,
  style,
  title,
}) => {
  // header could be element or string, render as title if string
  const hoverTitle = title || (typeof properties.column.columnDef.header === 'string' ? properties.column.columnDef.header : null);

  const sortIcons = {
    none: (
      <i className="fa fa-sort" aria-hidden="true"/>
    ),
    asc: (
      <i className="fa fa-sort-up" aria-hidden="true"/>
    ),
    desc: (
      <i className="fa fa-sort-down" aria-hidden="true"/>
    ),
  };

  useEffect(() => {
    const {initialSort} = properties.column.columnDef;
    if (initialSort !== undefined) {
      properties.column.toggleSorting(initialSort);
    }
  }, [properties.column]);

  const canSort = properties.column.getCanSort();
  const isSorted = properties.column.getIsSorted();
  const ariaSortValue = canSort
    ? (isSorted === 'asc' ? 'ascending' : isSorted === 'desc' ? 'descending' : 'none')
    : undefined;

  return <th
    key={properties.id}
    colSpan={properties.colSpan ? properties.colSpan : 1}
    style={{
      verticalAlign: 'middle',
      width: 'auto',
      display: properties.getSize() == 0 ? 'none' : '',
      ...style,
    }}
    className={colClassName || ''}
    title={hoverTitle}
    aria-sort={ariaSortValue}
  >
    {properties.isPlaceholder ? null :
      <div className='cell-container'>
        {canSort ?
          <button
            type="button"
            className='sort-button cursor-pointer select-none flex items-center sort'
            onClick={properties.column.getToggleSortingHandler()}
          >
            {properties.column.columnDef.header(properties.getContext())}
            {sortIcons[isSorted] ?? sortIcons.none}
          </button> :
          <span style={{display: 'inline-block'}}>
            {properties.column.columnDef.header(properties.getContext())}
          </span>
        }
      </div>
    }
  </th>;
};

Header.propTypes = {
  properties: PropTypes.shape({
    id: PropTypes.string,
    colSpan: PropTypes.number,
    isPlaceholder: PropTypes.bool,
    getResizeHandler: PropTypes.func,
    column: PropTypes.shape({
      columnDef: PropTypes.object,
      getCanSort: PropTypes.func,
      getToggleSortingHandler: PropTypes.func,
      getIsSorted: PropTypes.func,
      getCanFilter: PropTypes.func,
      getIsPinned: PropTypes.func,
      getIsResizing: PropTypes.func,
      getCanResize: PropTypes.func,
      toggleSorting: PropTypes.func,
    }),
    getSize: PropTypes.func,
    getContext: PropTypes.func,
  }),
  columnResizeMode: PropTypes.string,
  colClassName: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.string,
};

export default Header;
